import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import TopNav from "../../../components/TopNav";
import ButtomButton from "../../../components/DocButtomButton";
import {
  fetchDocumentInstructions,
  processUserDocument,
} from "../../../actions/document.action";
import ErrorInputComponent from "../../../components/ErrorInputComponent";
import { Loading } from "../../../utils/helpers/constants";

const ReceiverType = ({ name, handleChange }) => (
  <div className="flex items-center">
    <div class="flex items-center pl-0">
      <input
        defaultChecked
        type="radio"
        value="SELF"
        onChange={handleChange}
        name={name}
        className="checkbox-round mr-2 leading-tight focus:ring-green-500"
      />
      <label
        htmlFor="list-radio-license"
        className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
      >
        Send to Self
      </label>
    </div>
    <div class="flex items-center pl-3">
      <input
        type="radio"
        value="OTHERS"
        onChange={handleChange}
        name={name}
        className="checkbox-round mr-2 leading-tight focus:ring-green-500"
      />
      <label
        htmlFor="list-radio-id"
        className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
      >
        Send to Others
      </label>
    </div>
  </div>
);

const OthersComponent = ({ values, handleChange, errors }) => (
  <>
    <input
      className="mt-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
      id="inline-full-name"
      type="email"
      name="receiverEmail"
      onChange={handleChange}
      placeholder="Receiver Email"
    />
    <ErrorInputComponent error={errors.receiverEmail} />
  </>
);

export default function TranscriptUnofficial() {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [documentFee, setDocumentFee] = useState(0);
  const [alumniFee, setAlumniFee] = useState(0);
  const {
    documentInstruction: {
      instructions,
      instructionLoading,
      docModal,
      processDocumentLoading,
    },
  } = useSelector(({ documentReducer }) => ({
    documentInstruction: documentReducer,
  }));

  useEffect(() => {
    dispatch(fetchDocumentInstructions("TRANSCRIPT_UNOFFICIAL"));
  }, []);

  const validationSchema = Yup.object({
    // pathfinderEmail: Yup.string().when("receiverType", {
    //   is: "SELF",
    //   then: Yup.string().required("Pathfinder Email is required"),
    // }),

    receiverEmail: Yup.string().when("receiverType", {
      is: "OTHERS",
      then: Yup.string().required("Receiver Email is required"),
    }),

    privacy: Yup.boolean()
      .required("Privacy policy must be accepted.")
      .oneOf([true], "Privacy policy must be accepted."),
  });

  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      receiverType: "SELF",
      receiverEmail: "",
      // pathfinderEmail: "",
      privacy: false,
    },
    validationSchema,
    onSubmit(values) {
      const payload = {
        documentType: "TRANSCRIPT_UNOFFICIAL",
        privacy: values.privacy,
        transcriptDeliveryDto : {
          receiverEmail: values.receiverEmail,
          receiverType: values.receiverType,
        }
      };
      const modalText =
        "Your request for unofficial transcript is successful. Kindly check your email.";
      dispatch(processUserDocument(payload, modalText));
    },
  });

  const buttonState = processDocumentLoading === Loading.FETCHING;

  const InstructionComponent = ({ instruction }) => {
    return (
      <li>
        {instruction?.instruction}
        <span className="font-bold">
          {instruction?.costType === "ALUMNI_FEE" ? " N" + alumniFee : null}
          {instruction?.costType === "TRANSCRIPT_UNOFFICIAL"
            ? " N" + documentFee
            : null}
        </span>
      </li>
    );
  };

  return (
    <div className="overflow-hidden">
      <div className=" doc_processing_color h-44 px-2 pt-3">
        <TopNav />
        <div className="transcript_header">Unofficial Transcript</div>
        <div className="text-md w-2/3">
          Get access to your unofficial transcript
        </div>
      </div>
      <div className="px-2 md:mx-20 mt-2 md:mt-10">
        <div>
          <p className="font-semibold text-lg">Requirements:</p>
          <>
            {instructionLoading ? (
              <div>Loading....</div>
            ) : (
              <div className="px-4">
                <ul class="space-y-1 max-w-md list-disc list-inside">
                  {instructions.map((instruction, index) => {
                    return (
                      <InstructionComponent
                        instruction={instruction}
                        key={index}
                      />
                    );
                  })}
                </ul>
              </div>
            )}
          </>
        </div>
        <div className="md:flex md:flex-column md:justify-center">
          <div className="px-2 md:w-1/2 mt-0">
            <form>
              <ReceiverType name={"receiverType"} handleChange={handleChange} />
              {/* {values.receiverType === "SELF" && (
                <>
                  <input
                    className="mt-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                    id="inline-full-name"
                    type="email"
                    name="pathfinderEmail"
                    onChange={handleChange}
                    placeholder="Pathfinder Email"
                  />
                  <ErrorInputComponent error={errors.pathfinderEmail} />
                </>
              )} */}
              {values.receiverType === "OTHERS" && (
                <OthersComponent
                  handleChange={handleChange}
                  values={values}
                  errors={errors}
                />
              )}

              <div className="fle items-center my-5">
                <input
                  id="link-checkbox"
                  type="checkbox"
                  name="privacy"
                  onChange={handleChange}
                  className="checkbox-square mr-3 leading-tight focus:ring-green-500 w-full"
                />
                <label
                  htmlFor="link-checkbox"
                  className="ml-1 text-sm dark:text-gray-300"
                >
                  By submitting this form, I agree to the{" "}
                  <a href="/dashboard/privacy-policy" target="_blank">
                    privacy policy{" "}
                  </a>
                  and{" "}
                  <a href="/dashboard/terms&condition" target="_blank">
                    terms{" "}
                  </a>
                  of use of Landmark University Association.
                </label>
                <ErrorInputComponent error={errors.privacy} />
              </div>
            </form>
            <ButtomButton
              name={"Request"}
              func={handleSubmit}
              loading={buttonState}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
